import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../AxiosCoreInterceptor";
import {RequestTracker} from "../../Model/Dto/Staging/RequestTracker";
import * as ApiUrls from "./ApiUrl.RequestTracker";
export const RequestTrackerService = {
    searchRequests: (searchRequest: RequestTracker.SearchRequest): Promise<AxiosResponse<RequestTracker.SearchResponse>> =>
        axiosCoreInstance.post(`${ApiUrls.SearchOrganisationRequests}`, searchRequest),
    requestEmployees: (organisationId: number): Promise<AxiosResponse<boolean>> => axiosCoreInstance.post(`${ApiUrls.RequestEmployees}?organisationId=${organisationId}`),
    getLatestRequestTracker: (organisationId: number): Promise<AxiosResponse<RequestTracker.RequestTrackerDetail>> => axiosCoreInstance.get(ApiUrls.LastestRequest + organisationId),
};